/**
 * Height of the chrome docked at the bottom-right corner of the viewport —
 * currently the collapsed chat inbox drawer.
 *
 * The dock is conditional: logged-out visitors, mobile, and routes that opt out
 * have none. Rather than have every floating control re-derive those
 * conditions, whatever owns the dock publishes its height on the root element
 * while it is on screen, and controls that must clear it read the variable.
 * Unset means no dock, so consumers should default to `0px` and sit at the
 * viewport floor.
 */
export const FLOATING_DOCK_HEIGHT_VAR = '--floating-dock-height';

/** Gap between the viewport floor (or the dock above it) and floating controls. */
export const FLOATING_DOCK_GAP_REM = 1.25;

/** `bottom` for a floating control that must stack above the dock when present. */
export const floatingDockOffset = () =>
    `calc(var(${FLOATING_DOCK_HEIGHT_VAR}, 0px) + ${FLOATING_DOCK_GAP_REM}rem)`;
